import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';

// HydratedFlowEgg is the correct request shape but does not match up with how we've historically created flows

export const CREATE_FLOW = registerMutation({
  fieldName: 'createdFlow',
  args: [],
  fetcher: ({
    //aiAssistants,
    businessUnitId,
    folderId,
    flow
  }) => http.post('automationplatform/v1/hybrid/create', {
    data: flow,
    query: {
      //aiAssistants,
      businessUnitId,
      folderId,
      sourceapp: SourceApps.WORKFLOWS_APP
    }
  })
});